import { BranchLecturerRatesGroupDB } from '../../../../../api/types/lecturers/user-details-lecturer';

export const hasOverlap = (
  rates: BranchLecturerRatesGroupDB[],
  branchId: number | undefined,
  activityTypeId: number | undefined,
  startDate: Date,
  endDate: Date,
): boolean => {
  if (!branchId || !activityTypeId) {
    return false;
  }

  const rateGroup = rates.find(
    (group) =>
      group.branchId === branchId &&
      group.settingsActivityTypeId === activityTypeId,
  );

  if (!rateGroup) {
    return false;
  }

  return rateGroup.rates.some((rate) => {
    // Compare dates directly as timestamps
    const newStart = startDate.getTime();
    const newEnd = endDate.getTime();
    const existingStart = new Date(rate.startTime).getTime();
    const existingEnd = new Date(rate.endTime).getTime();

    // Two time periods overlap if one starts before the other ends
    return newStart <= existingEnd && existingStart <= newEnd;
  });
};
